export default __webpack_public_path__ + "static/media/email.caba6344.svg";